import * as APICommon from "../APICommon";
import appConstants from "../../appConstants";
import APIConfig from "../APIConfig";
import * as AppUtils from "../../Utils/AppUtils";
import * as types from '../ActionTypes';

export function changePasswordDataAction(changePasswordData)
{
	return { type: types.CHANGE_PASSWORD_RESPONSE, changePasswordData };
}

export function changePasswordErrorAction(changePasswordErrorFlag)
{
	return { type: types.CHANGE_PASSWORD_ERROR, changePasswordErrorFlag };
}

export function changePasswordLoadingAction(changePasswordLoading)
{
	return { type: types.CHANGE_PASSWORD_LOADING, changePasswordLoading: changePasswordLoading };
}

export function forgotPasswordDataAction(forgotPasswordData)
{
	return { type: types.FORGOT_PASSWORD_RESPONSE, forgotPasswordData };
}

export function forgotPasswordErrorAction(forgotPasswordErrorFlag)
{
	return { type: types.FORGOT_PASSWORD_ERROR, forgotPasswordErrorFlag };
}

export function forgotPasswordLoadingAction(forgotPasswordLoading)
{
	return { type: types.FORGOT_PASSWORD_LOADING, forgotPasswordLoading: forgotPasswordLoading };
}

export function loginErrorAction(loginErrorFlag)
{
	return { type: types.LOGIN_ERROR, loginErrorFlag };
}

export function loginLoadingAction(loginLoading)
{
	return { type: types.LOGIN_LOADING, loginLoading: loginLoading };
}

export function loginDataAction(loginData)
{
	return { type: types.LOGIN_RESPONSE, loginData };
}

export function loginSuccessAction(loginSuccessFlag)
{
	return { type: types.LOGIN, loginSuccessFlag };
}

export function logout(logoutFlag)
{
	AppUtils.clearDynamicApiBaseUrl();
	return { type: types.LOGOUT, logoutFlag };
}

export function updateUserLicenseAgreementStatusErrorAction(updateUserLicenseAgreementStatusErrorFlag)
{
	return { type: types.UPDATE_USER_LICENSE_AGREEMENT_STATUS_ERROR, updateUserLicenseAgreementStatusErrorFlag}
}

export function updateUserLicenseAgreementStatusLoadingAction(updateUserLicenseAgreementStatusLoading)
{
	return { type: types.UPDATE_USER_LICENSE_AGREEMENT_STATUS_LOADING, updateUserLicenseAgreementStatusLoading}
}

export function updateUserLicenseAgreementStatusAction()
{
	return { type: types.UPDATE_USER_LICENSE_AGREEMENT_STATUS }
}

export function updateUserPasswordChangeRequiredStatusAction()
{
	return { type: types.UPDATE_USER_PASSWORD_CHANGE_REQUIRED_STATUS }
}

export function feedbackTokenVerificationSuccessAction(feedbackTokenVerificationSuccess)
{
	return { type: types.FEEDBACK_TOKEN_VERIFICATION_SUCCESS, feedbackTokenVerificationSuccess: feedbackTokenVerificationSuccess };
}

export function feedbackTokenVerificationLoadingAction(feedbackTokenVerificationLoading)
{
	return { type: types.FEEDBACK_TOKEN_VERIFICATION_LOADING, feedbackTokenVerificationLoading: feedbackTokenVerificationLoading };
}

export function feedbackTokenVerificationErrorAction(feedbackTokenVerificationErrorFlag)
{
	return { type: types.FEEDBACK_TOKEN_VERIFICATION_ERROR, feedbackTokenVerificationErrorFlag };
}

export function siginIn(username, password, customerDomain)
{
	var tokenValue = "";

	var loginObjWithCustomerDomain =
	{
		username: username,
		password: password,
		customerDomain: customerDomain
	};

	var loginObj =
	{
		username: username,
		password: password
	};

	return dispatch => 
	{
		dispatch(loginLoadingAction(true));
		var tokenAuthenticationURL = APIConfig.tokenAuthenticationURL;
		APICommon.postMethod(tokenAuthenticationURL, APIConfig.headers, loginObjWithCustomerDomain, 
			function(response)
			{
				if(!response.errorOccured)
				{
					if (response.status != APIConfig.SUCCESS_STATUS_CODE)
					{
						dispatch(loginLoadingAction(false));
					}
					tokenValue = response.headers.authorization; //response.headers.map.authorization;
					if(!response.data || !response.data.authFlag || !tokenValue)
					{
						console.log(response.data)
						dispatch(loginDataAction(response.data));
						dispatch(loginLoadingAction(false));
						dispatch(loginSuccessAction(false));
						return;
					} 

					var headers = APIConfig.headers
					headers.Authorization = tokenValue
					var loginAuthenticationURL = APIConfig.loginAuthenticationURL;
					APICommon.postMethod(loginAuthenticationURL, headers, loginObj, 
						function(loginResponse)
						{
							if(!loginResponse.errorOccured)
							{
								if(loginResponse.status != APIConfig.SUCCESS_STATUS_CODE)
								{
									dispatch(loginLoadingAction(false));
									dispatch(loginSuccessAction(false));
								}
								loginResponse.data.token = tokenValue;
								if(loginResponse.data && loginResponse.data.authFlag && loginResponse.data.errorMessage == "SUCCESS")
								{
									dispatch(loginDataAction(loginResponse.data));
									dispatch(loginSuccessAction(true));
									dispatch(loginLoadingAction(false));
									dispatch(loginErrorAction(false));
								} else
								{
									dispatch(loginLoadingAction(false));
									dispatch(loginSuccessAction(false));
								}
							} else 
							{
								dispatch(loginLoadingAction(false));
								dispatch(loginErrorAction(true));
							}
						});
				} else
				{
					dispatch(loginLoadingAction(false));
					dispatch(loginErrorAction(true));
				}
			}
		);
	}
}

export function changePassword(userId, oldPassword, newPassword)
{
	return dispatch => 
	{
		dispatch(changePasswordLoadingAction(true));
		var changePasswordURL = APIConfig.changePasswordURL;
		
		var body =
		{
			"userId": userId,
			"oldPassword": oldPassword,
			"password": newPassword
		};
		APICommon.postMethod(changePasswordURL, APIConfig.headers, body,
			function(response)
			{
				if(!response.errorOccured)
				{
					if (response.status != APIConfig.SUCCESS_STATUS_CODE || !response.data)
					{
						dispatch(changePasswordErrorAction(true));
						dispatch(changePasswordLoadingAction(false));
						return;
					}
					
					if(response.data)
					{
						var changePasswordResponse = (response.data ? response.data : {});
						dispatch(changePasswordErrorAction(false));
						dispatch(changePasswordLoadingAction(false));
						dispatch(changePasswordDataAction(changePasswordResponse));
					} 
				} else
				{
					dispatch(changePasswordErrorAction(true));
					dispatch(changePasswordLoadingAction(false));
				}
			})
	}
}

export function forgotPassword(userName, customerDomain)
{
	return dispatch => 
	{
		dispatch(forgotPasswordLoadingAction(true));
		var forgotPasswordURL = APIConfig.forgotPasswordURL;
		
		var userObj =
		{
			customerDomain: customerDomain,
			username: userName
		};
		APICommon.postMethod(forgotPasswordURL, APIConfig.headers, userObj,
			function(response)
			{
				if(!response.errorOccured)
				{
					if (response.status != APIConfig.SUCCESS_STATUS_CODE || !response.data)
					{
						dispatch(forgotPasswordErrorAction(true));
						dispatch(forgotPasswordLoadingAction(false));
						return;
					}
					
					if(response.data)
					{
						var forgotPasswordResponse = (response.data.outputData ? response.data.outputData : {});
						dispatch(forgotPasswordErrorAction(false));
						dispatch(forgotPasswordLoadingAction(false));
						dispatch(forgotPasswordDataAction(forgotPasswordResponse));
					} 
				} else
				{
					dispatch(forgotPasswordErrorAction(true));
					dispatch(forgotPasswordLoadingAction(false));
				}
			})
	}
}

export function updateUserLicenseAgreementStatus(userId)
{
	return dispatch => 
	{
		dispatch(updateUserLicenseAgreementStatusLoadingAction(true));
		var updateUserLicenseAgreementStatusUrl = APIConfig.updateUserLicenseAgreementStatus;
		
		var body =
		{
			"userId": userId,
		};
		APICommon.postMethod(updateUserLicenseAgreementStatusUrl, APIConfig.headers, body,
			function(response)
			{
				if(!response.errorOccured)
				{
					if (response.status != APIConfig.SUCCESS_STATUS_CODE || !response.data)
					{
						dispatch(updateUserLicenseAgreementStatusErrorAction(true));
						dispatch(updateUserLicenseAgreementStatusLoadingAction(false));
						return;
					}
					
					if(response.data)
					{
						var user = (response.data.outputData ? response.data.outputData.user : {});
						dispatch(updateUserLicenseAgreementStatusErrorAction(false));
						dispatch(updateUserLicenseAgreementStatusLoadingAction(false));
						dispatch(updateUserLicenseAgreementStatusAction());
					} 
				} else
				{
					dispatch(updateUserLicenseAgreementStatusErrorAction(true));
					dispatch(updateUserLicenseAgreementStatusLoadingAction(false));
				}
			})
	}
}

export function fetchLoginUserDetails(userId)
{
	return (dispatch) => 
	{
		dispatch(loginLoadingAction(true));
		var loginUserDetailsURL = APIConfig.loginUserDetailsURL + userId;
		APICommon.getMethod(loginUserDetailsURL, APIConfig.headers, 
			function(response)
			{
				if(!response.errorOccured)
				{
					if (response.status != APIConfig.SUCCESS_STATUS_CODE || !response.data)
					{
						dispatch(loginLoadingAction(false));
						dispatch(loginSuccessAction(false));
						return;
					}
					
					if(response.data)
					{
						var existingLoginUserDetails = AppUtils.getSessionStorageData(appConstants.USER_SESSION_KEY);
						var loginResponse = {...existingLoginUserDetails, ...response.data};

						AppUtils.saveSessionStorageData(appConstants.USER_SESSION_KEY, loginResponse);
						dispatch(loginDataAction(loginResponse));
						dispatch(loginSuccessAction(true));
						dispatch(loginLoadingAction(false));
						dispatch(loginErrorAction(false));
					} 
				} else
				{
					dispatch(loginLoadingAction(false));
					dispatch(loginSuccessAction(false));
				}
			})
	}
}

export function verifyToken(token, customerDomain)
{
	let jwtToken = "";

	let loginObj =
	{
		token: token,
		customerDomain: customerDomain
	};

	return dispatch => 
	{
		dispatch(feedbackTokenVerificationLoadingAction(true));
		APICommon.postMethod(APIConfig.verifyFeedbackTokenURL, APIConfig.headers, loginObj, 
			function(response)
			{
				if(!response.errorOccured && response.status === APIConfig.SUCCESS_STATUS_CODE)
				{
					jwtToken = response.headers.authorization;
					if(!jwtToken)
					{
						dispatch(feedbackTokenVerificationErrorAction(true));
						return;
					}

					AppUtils.saveSessionStorageData(appConstants.USER_SESSION_KEY, {
						token: jwtToken,
						userId: response.data.userId,
						username: response.data.username,
						firstName: response.data.firstName,
						lastName: response.data.lastName,
						userType: response.data.userType,
						loginType: appConstants.LOGIN_TYPE_FEEDBACK,
						customerDomain: customerDomain,
						feedbackToken: token
					});
					dispatch(feedbackTokenVerificationSuccessAction(true));
				} else
				{
					dispatch(feedbackTokenVerificationErrorAction(true));
				}
			}
		);
		dispatch(feedbackTokenVerificationLoadingAction(false));
	}
}